import { useAxios } from "utils/axiosHook";

const useGetGrades = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/grades",
      method: "GET",
    },
    { manual: true }
  );

  const service = () => {
    return api();
  };

  return { data, loading, error, service };
};

const useAddGrade = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/grades",
      method: "POST",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useUpdateGrade = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/grades",
      method: "PUT",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useDeleteGrades = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/grades",
      method: "DELETE",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

export { useGetGrades, useAddGrade, useUpdateGrade, useDeleteGrades };
